import React from 'react';
import './index.scss';
import iconGood from '@/pages/opinion/assets/svg/icon-good.svg';
import iconNoGood from '@/pages/opinion/assets/svg/icon-nogood.svg';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { DBO_V } from '@op/utils/format';

const VoteBarChart = ({
  upVotes = 0,
  downVotes = 0,
  totalReview = 0,
}: {
  upVotes?: number;
  downVotes?: number;
  totalReview?: number;
}) => {
  const upPercentage = DBO_V.percentage(upVotes, totalReview, 0);
  const downPercentage = DBO_V.percentage(downVotes, totalReview, 0);

  const formatNumber = (num: number) => num.toLocaleString();

  return (
    <div className="dbo-vote-bar-chart dbo-videobox-cover">
      {/* 赞成票进度条 */}
      <div className="dbo-vote-bar dbo-vote-bar--up">
        <div className="dbo-vote-icon">
          <SvgIcon type="good-icon" className="dbo-vote-bar-good-icon" />
        </div>
        <div className="dbo-bar-container">
          <div className="dbo-bar-fill" style={{ width: `${upPercentage}` }}>
            {/* <span className="dbo-percentage-label">{upPercentage}%</span> */}
          </div>
          <div className="dbo-vote-stats">
            {formatNumber(upVotes)} ({upPercentage})
          </div>
        </div>
      </div>

      {/* 反对票进度条 */}
      <div className="dbo-vote-bar dbo-vote-bar--down">
        <div className="dbo-vote-icon">
          <SvgIcon type="no-good-icon"  className="dbo-vote-bar-nogood-icon"/>
        </div>
        <div className="dbo-bar-container" style={{ width: `${downPercentage}` }}>
          <div className="dbo-bar-fill" style={{ width: `${downPercentage}` }}>
            {/* <span className="dbo-percentage-label">{downPercentage}%</span> */}
          </div>
          <div className="dbo-vote-stats">
            {formatNumber(downVotes)} ({downPercentage})
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoteBarChart;
